import React from 'react'

import { Form, Col } from '_zari/core'

import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableFormGroup = ({ iError, iTouched, iReadonlyInfo, setFieldValue }) => {
  return (
    <Form.Group>
      <Form.Label text='CUENTA' htmlFor='input-cuentaContable' md={4} alignRightAt='md' />
      <Col md={8}>
        {iReadonlyInfo ? <ClearInputGroup id='readonly-cuentaContable' iValue={iReadonlyInfo} /> : <></>}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
